
import { AsyncThunkAction } from "@reduxjs/toolkit";
import { getWebCustomerList } from "../../../store/slices/webCustomersSlice";
import { Dispatch } from "react";

export function refreshCustomerTable(dispatch: Dispatch<AsyncThunkAction<any, any, any>>,
  page: number = 1, 
  pageSize: number = 10
) {
  const parameters: any = {
    customername: "",
    customercode: "",
    matchedUserType: 0,
    phone: "",
    email: "",
    cityIds: null,
    districtIds: null,
    tcCodeTaxCode: "",
    pageNumber: page,
    pageSize: pageSize
  };
  dispatch(getWebCustomerList(parameters));
}
